/* eslint-disable @typescript-eslint/no-unsafe-function-type */
export function getFunctionName(fn) {
    return fn.name || '[anonymous Function]';
}
